// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"371ab0d2","57":"2b585a28","77":"b55078a5","166":"f8dc467f","227":"71ea5620","289":"9935927b","524":"b49611e7","664":"60a69e1c","682":"877c37bd","697":"e49be376","711":"f43823e9","740":"08a3bbd9","747":"63d3dc47","806":"559cd796","839":"9141965a","965":"6d8f5525"}[chunkId] + ".chunk.js";
};